<template>
  <v-card flat>
    <v-card-title class="grey--text text-subtitle-1">
      Eventi Registrati
      <v-btn
        outlined
        class="ml-6"
        color="green"
        @click="$refs.nuovo_evento.open()"
        ><v-icon class="mr-2">mdi-plus</v-icon>Aggiungi Evento</v-btn
      >
      <NuovoEvento ref="nuovo_evento" />
      <v-spacer> </v-spacer>
      <v-btn icon color="purple" @click="view_mode = 1"
        ><v-icon>mdi-calendar</v-icon></v-btn
      >
      <v-btn icon color="blue" @click="view_mode = 0"
        ><v-icon>mdi-format-list-bulleted-square</v-icon></v-btn
      >
    </v-card-title>
    <v-card-text>
      <v-divider class="mb-4" />
      <v-row>
        <v-col cols="2">
          <v-select
            label="Anno di Riferimento"
            outlined
            :items="anni"
            v-model="anno_rif"
            hide-details
          />
        </v-col>
        <v-col cols="3">
          <v-btn outlined color="purple" x-large @click="stampaPdf()">
            <v-icon class="mr-2">mdi-printer</v-icon> Stampa
          </v-btn>
        </v-col>
      </v-row>
      <template v-if="view_mode == 0">
        <v-row class="text-caption font-weight-medium grey--text text--darken-1">
          <v-col cols="1"> Data </v-col>
          <v-col cols="4">
            <v-row no-gutters>
              <v-col cols="8">Prodotto Utilizzato</v-col>
              <v-col cols="4">Dose</v-col>
            </v-row>
          </v-col>
          <v-col cols="1"> Acqua </v-col>
          <v-col cols="2">Avversità</v-col>
          <v-col cols="1"> Zone Trattate </v-col>
          <v-col cols="1"> Fase Fenologica</v-col>
          <v-col cols="2"> Azioni</v-col>
        </v-row>
        <v-divider class="my-4" />
        <template v-for="evento in eventi">
          <Evento
            :key="evento.id"
            :evento="evento"
            @apri-mappa="$refs.mappa_evento.open($event)"
            @modifica-evento="$refs.nuovo_evento.apri_modifica($event)"
          />
          <v-divider class="my-2" :key="evento.id + '-div'" />
        </template>
        <EventoMappaDialog ref="mappa_evento" />
      </template>
      <template v-else>
        <v-toolbar tile elevation="0">
          <v-toolbar-title v-if="$refs.calendar">
            {{ $refs.calendar.title }}
          </v-toolbar-title>
          <v-btn icon class="ma-2" @click="$refs.calendar.prev()">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn icon class="ma-2" @click="$refs.calendar.next()">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-toolbar>
        <v-calendar
          ref="calendar"
          v-model="value"
          type="month"
          :events="events"
          :event-overlap-threshold="30"
          :event-color="getEventColor"
          @change="getEvents"
        ></v-calendar>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
// import moment from "moment";
import NuovoEvento from "./nuovo_evento_dialog.vue";
import Evento from "./evento_list_element.vue";
import EventoMappaDialog from "./EventoMappaDialog.vue";
import eventi_tab_mixin from "../mixin/eventi_tab_mixin";
export default {
  components: {
    NuovoEvento,
    Evento,
    EventoMappaDialog,
  },
  mixins: [eventi_tab_mixin],
  methods: {
    stampaPdf() {
      // Generato lato server (reportlab, layout tabellare vero con
      // paginazione corretta) invece che nel browser via jsPDF, che
      // renderizzava male su più pagine. Apertura in nuova scheda via
      // submit di form: il token va nel body, non in un header
      // Authorization, per poter usare un semplice <form target="_blank">
      // senza passare da axios.
      let url =
        process.env.VUE_APP_API_ROOT +
        "/admin/qdc/eventi/anno/" +
        this.anno_rif +
        "/pdf";
      let token = this.$store.getters.get_token;
      let form = document.createElement("form");
      form.target = "_blank";
      form.method = "POST";
      form.action = url;
      form.style.display = "none";
      let input = document.createElement("input");
      input.type = "hidden";
      input.name = "token";
      input.value = token;
      form.appendChild(input);
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);
    },
  },
};
</script>